import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import { Button, ButtonGroup, Icon } from 'ui';
import * as templateActions from '../../actions/editor/template';

const LessonTemplateUpdateModal = ({
  closeModal,
  lessonTitle,
  lessonDescription,
  onTemplateDetailsChange,
}) => {
  const [formData, setFormData] = useState({
    title: lessonTitle,
    description: lessonDescription,
  });

  const [disabled, setDisabled] = useState(true);

  const preventLineBreaks = e => {
    if (e.key === 'Enter') e.preventDefault();
  };

  const handleInputChange = e => {
    const { name } = e.target;
    let { value } = e.target;

    if (name === 'description') {
      value = value.replace(/\r?\n|\r/g, ' ');
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    onTemplateDetailsChange(formData);
    closeModal();
  };

  useEffect(() => {
    const { title, description } = formData;
    setDisabled(title === lessonTitle && description === lessonDescription);
  }, [formData, lessonTitle, lessonDescription]);

  return (
    <RenderInBody>
      <ModalContainer
        className="ModalTakeover-background Modal-background d-f ai-c"
        onEscape={closeModal}
      >
        <div className="ModalTakeover-container TemplateCreationModal">
          <div className="TemplateCreationModal-body">
            <form onSubmit={handleSubmit}>
              <div className="TemplateCreationModal-title">
                {t('templates.update_modal.title')}
              </div>
              <label
                htmlFor="title"
                className="TemplateCreationModal-inputTitle"
              >
                {t('common.title')}
              </label>
              <input
                id="title"
                name="title"
                onChange={handleInputChange}
                value={formData.title}
                className="NewInput NewInput--white NewInput--fw ModalTakeover-nameInput"
                placeholder={t('common.enter_title')}
                type="text"
                maxLength="255"
              />
              <label
                htmlFor="description"
                className="TemplateCreationModal-inputTitle"
              >
                {t('common.description')}
              </label>
              <textarea
                id="description"
                name="description"
                onChange={handleInputChange}
                value={formData.description}
                className="NewInput NewInput--white NewInput--fw"
                placeholder={t(
                  'contents.library.template_library.create_modal.enter_description',
                )}
                rows="6"
                onKeyDown={preventLineBreaks}
              />
              <ButtonGroup alignEnd className="mt-32">
                <Button onClick={closeModal}>Cancel</Button>
                <Button type="submit" customColor disabled={disabled}>
                  Save
                </Button>
              </ButtonGroup>
            </form>

            <button
              type="button"
              className="u-resetBtn ModalTakeover-closeButton"
              onClick={closeModal}
            >
              <Icon name="error" />
            </button>
          </div>
        </div>
      </ModalContainer>
    </RenderInBody>
  );
};

const mapStateToProps = ({ editor }) => ({
  lessonTitle: editor.lessonTitle,
  lessonDescription: editor.lessonDescription,
});

const mapDispatchToProps = (dispatch, { id }) => ({
  onTemplateDetailsChange(formData) {
    dispatch(templateActions.requestUpdate(id, formData));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LessonTemplateUpdateModal);
